<template>
  <v-row>
    <v-col cols="6">
      <!-- 仕入先名 -->
      <SelectSupplierName v-model="inputedValue" />
    </v-col>
    <v-col cols="6"> </v-col>
  </v-row>
</template>

<script>
import { SelectSupplierName } from '@/components/items/Selectboxes'

export default {
  components: {
    SelectSupplierName
  },
  props: {
    value: {}
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
